var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({class:_vm.classes,attrs:{"disabled":_vm.loading || _vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[(!_vm.loading)?_c('div',{staticClass:"content"},[_vm._t("default")],2):_c('img',{staticClass:"loading",attrs:{"src":require('@assets/loader.gif')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }